export function activitiesExpand() {
    const items = document.querySelectorAll(".activities__list-item");

    items.forEach(item => {
      item.addEventListener("click", function() {
        const content = this.querySelector(".activities__list-item__content");
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          content.style.paddingTop = "0";
          content.parentNode.classList.remove("activities__list-item--active");
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          content.parentNode.classList.add("activities__list-item--active");
          content.style.paddingTop = "20px";
        }
      });
    });
}